

















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
import i18n from "@/i18n";
// components
import vSelect from "vue-select";
import moment from "moment";
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import { calendarConfigs } from "@/services/functional-calendar";
// service methods
import { getUserActivityLogs, getEtityTypes } from "@/services/userActivityLogs/userActivityLogService";
// types
import {
    UserActivityLog,
    UserActivityLogFilter,
    UserActivityLogType
} from "@/services/userActivityLogs/types";
import { activityLogsFilters } from "@/components/userActivityLogs/fields/activityLogsFilters";

    @Component({
        components: {
            vSelect,
            FunctionalCalendar
        }
    })
export default class ActivityLogs extends Vue {
        // local state
        activityLogs = [] as UserActivityLog[];
        fields = activityLogsFilters;
        isBusy = false;
        activityTypes: any = Object.keys(UserActivityLogType)
            .filter(key => isNaN(Number(key)))
            .map((key, value) => ({ name: i18n.t(`userActvityLog.${key}`), id: value }));

        // filter options
        date = new Date();
        filter = {
            sortBy: "timeStampOnUtc",
            isDescending: true,
            fromDate: this.date.toDateString(),
            toDate: new Date().toDateString()
        } as UserActivityLogFilter;

        currentPage = 1;

        pageSize = 30;
        totalItems = 0;
        sortBy = "timeStampOnUtc";
        isDescending = true;
        entityTypes = [] as string[];

        @Watch("currentPage")
        onPropertyChanged(value: boolean, oldValue: any) {
            this.fetchData();
        }

        @Watch("sortBy")
        onSortChanged(value: any, oldValue: any) {
            this.filter.sortBy = this.sortBy;
            this.fetchData();
        }

        @Watch("isDescending")
        onDirectionChanged(value: boolean, oldValue: any) {
            this.filter.isDescending = this.isDescending;
            this.fetchData();
        }

        // lifecycle hooks
        mounted() {
            this.date.setDate(this.date.getDate() - 1);
            (this.$refs.calendarFromDate as any).clickDay({
                day: this.date.getDate(),
                date: `${this.date.getDate()}/${this.date.getMonth() + 1}/${this.date.getFullYear()}`,
                isMarked: true
            });
            var toDate = new Date();
            (this.$refs.calendarToDate as any).clickDay({
                day: toDate.getDate(),
                date: `${toDate.getDate()}/${toDate.getMonth() + 1}/${toDate.getFullYear()}`,
                isMarked: true
            });
        }

        async created() {
            this.entityTypes = await getEtityTypes();

            bus.$on("reload", () => {
                this.fetchData();
            });
        }

        beforeDestroy() {
            bus.$off("reload");
        }

        // computed
        get filteredData() {
            return this.activityLogs;
        }

        get calendarConfigs() {
            return calendarConfigs();
        }

        get fromDate() {
            return {
                currentDate: new Date(),
                selectedDate: new Date(this.filter.fromDate)
            };
        }

        set fromDate(date: any) {
            const dateParts = date.selectedDate.split("/");
            // month is 0-based, that's why we need dataParts[1] - 1
            const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            this.filter.fromDate = dateObject.toDateString();
        }

        get toDate() {
            return {
                currentDate: new Date(),
                selectedDate: this.filter.toDate
            };
        }

        set toDate(date: any) {
            const dateParts = date.selectedDate.split("/");
            // month is 0-based, that's why we need dataParts[1] - 1
            const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            this.filter.toDate = dateObject.toDateString();
        }

        // methods
        fetchData() {
            this.isBusy = true;
            this.filter.limitPerPage = this.pageSize;
            this.filter.currentPage = this.currentPage;
            getUserActivityLogs(this.filter).then(response => {
                this.totalItems = response.totalItems;
                this.activityLogs = response.items;
                this.isBusy = false;
            });
        }

        clearFilter() {
            this.filter = {
                sortBy: "timeStampOnUtc",
                isDescending: true,
                fromDate: this.filter.fromDate,
                toDate: this.filter.toDate,
                searchQuery: this.filter.searchQuery
            } as UserActivityLogFilter;
            this.fetchData();
        }

        clearSearch() {
            this.filter.searchQuery = "";
            this.fetchData();
        }

        getFromDateLabel() {
            return i18n.d(new Date(this.filter.fromDate), "short");
        }

        getToDateLabel() {
            return i18n.d(new Date(this.filter.toDate), "short");
        }

        dayClicked() {
            this.fetchData();
        }
}
